import BottomSheet from '../../../../components/ui/BottomSheet';
import Button from '../../../../components/ui/Button';

/**
 * "Leave testing session?" confirm — raised from the summary sheet's
 * "Back to Dashboard" when untested assets remain (spec §6, §8). Distinct from
 * the Finish Session gate: leaving keeps the session resumable, finishing
 * completes it.
 *
 * Props:
 *   open          — controlled open state
 *   onKeepTesting — dismiss and stay in the session (also the scrim/ESC handler)
 *   onLeave       — navigate to the dashboard, leaving the session resumable
 */
export default function ExitConfirmSheet({ open, onKeepTesting, onLeave }) {
  return (
    <BottomSheet open={open} onClose={onKeepTesting}>
      <div className="exit-confirm-sheet">
        <div className="exit-confirm-sheet__header">
          <h2 className="exit-confirm-sheet__title">Leave testing session?</h2>
          <p className="exit-confirm-sheet__subtitle">
            Your progress is saved automatically. You can resume this session
            from the dashboard.
          </p>
        </div>

        <div className="exit-confirm-sheet__actions">
          <Button
            variant="primary"
            className="exit-confirm-sheet__cta"
            onClick={onKeepTesting}
          >
            Keep testing
          </Button>
          <Button
            variant="secondary"
            className="exit-confirm-sheet__cta"
            onClick={onLeave}
          >
            Leave to Dashboard
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
}
